import { Button } from "@/components/ui/button";
import TrustSection from "./TrustSection";
import { trackAffiliateClick } from "@/utils/analytics";
import { getAffiliateUrl } from "@/constants/affiliate";

const Hero = () => {
  const handleAffiliateClick = () => {
    trackAffiliateClick('cta-hero-primary', 'hero-primary');
  };
  return (
    <section className="relative overflow-hidden bg-crystal-gradient py-8 md:py-24">
      <div className="absolute inset-0 bg-[url('/pattern-dots.svg')] bg-repeat opacity-20"></div>
      
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="flex flex-col md:flex-row gap-4 md:gap-8 items-center">
          {/* Text content */}
          <div className="md:w-1/2 space-y-3 md:space-y-6 w-full">
            <article className="space-y-3 md:space-y-4 text-left">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-medium leading-tight text-foreground">
                Turn Every Sip Into a <span className="text-primary font-bold">Wellness Ritual</span>
              </h1>
              
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
                Crystal-infused water bottle that transforms daily hydration into a beautiful wellness practice.
              </p>
            </article>
            
            {/* Benefits */}
            <div className="space-y-3 text-base text-muted-foreground">
              <div className="flex items-start gap-3">
                <span className="text-primary text-xl" aria-hidden="true">✓</span>
                <span>9 natural crystals including Amethyst, Clear Quartz & Rose Quartz</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-primary text-xl" aria-hidden="true">✓</span>
                <span>Transform daily hydration into a beautiful wellness practice</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-primary text-xl" aria-hidden="true">✓</span>
                <span>Support your energy, clarity and mindful living</span>
              </div>
            </div>
            
            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a href={getAffiliateUrl("hero-primary")} rel="sponsored nofollow noopener" target="_blank" id="cta-hero-primary" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-6 text-lg font-semibold shadow-lg w-full sm:w-auto" onClick={handleAffiliateClick}>
                Get Your SlimCrystal Bottle
              </a>
              <a href="#learn-more" id="cta-hero-secondary" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-primary text-primary hover:bg-primary/10 px-8 py-6 text-lg font-semibold w-full sm:w-auto">
                See How It Works
              </a>
            </div>
            
            <TrustSection />
          </div>
          
          {/* Product image - on mobile appears after CTA */}
          <div className="md:w-1/2 flex justify-center my-4 md:mt-0">
            <div className="relative">
              <div className="absolute -inset-4 rounded-full bg-white/20 blur-xl animate-pulse-gentle"></div>
              <img 
                  src="/lovable-uploads/d5cbf445-bc6d-47dd-830c-39fd29f958d5.png" 
                  alt="SlimCrystal Water Bottle with Crystal Infusion" 
                  className="relative w-64 md:w-72 animate-float"
                  width={288}
                  height={480}
                  fetchPriority="high"
                  decoding="async"
                />
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-background to-transparent"></div>
    </section>
  );
};

export default Hero;
